import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { NavigationModule } from 'cax-design-system/navigation';
import { LoginService } from './services/login.service';
import { BehaviorSubject, filter } from 'rxjs';
import { SharedService } from './services/shared.service';
import { AuthService } from '@auth0/auth0-angular';
// import { environment } from '../environments/environment';
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NavigationModule, CommonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    toggleNav: boolean = false;
    location: any = null;
    userData: any = '';
    activeTab = new BehaviorSubject<any>({ position: 'top', index: 0 });
    topNavList = [
        {
            label: 'Home',
            icon: 'cax-home2',
            routePath: '/app/home',
            toolTip:true,
            toolTipVal:'Home',
            command: () => {
                this.router.navigate(['app/home']);
            },
        },
        {
            label: 'Tickets',
            icon: 'cax-notes',
            routePath: '/app/tickets',
            toolTip:true,
            toolTipVal:'Tickets',
            command: () => {
                this.router.navigate(['app/tickets']);
            },
        },
    ];

    constructor(
        private router: Router,
        private loginService: LoginService,
        private sharedService: SharedService,
        private auth0: AuthService
    ) {
        this.handleRedirectErrors();
    }

    ngOnInit(): void {
        // Step 2: Auth flow
        this.auth0.isAuthenticated$.subscribe(async isAuthenticated => {
            if (isAuthenticated) {
                this.handleAuthenticatedUser();
            } else {
                try {
                    // Step 3: Try silent login first
                    await this.auth0.getAccessTokenSilently().toPromise();
                    this.handleAuthenticatedUser();
                } catch (silentError) {
                    console.warn(
                        'Silent auth failed, redirecting to login...',
                        silentError
                    );

                    try {
                        // Step 4: If silent fails, try redirect login
                        await this.auth0.loginWithRedirect();
                    } catch (redirectError) {
                        console.error(
                            'loginWithRedirect failed BEFORE navigation:',
                            redirectError
                        );
                        this.handleLogout(); // Fallback
                    }
                }
            }
        });
        this.router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd =>
                        event instanceof NavigationEnd
                )
            )
            .subscribe((event: NavigationEnd) => {
                // added this when directly changing the url to login(Temporary fix)
                if (event.url === '/login') {
                    this.onLogoutClick();
                }

                const activeTab =
                    event.url === '/app/help'
                        ? 'help-centre'
                        : this.getActiveTabFromUrl(event.url);

                this.activeTab.next(activeTab);
            });
        this.sharedService.userData$.subscribe(user => {
            this.userData = user;
        });
        if (!this.userData) {
            const data = localStorage.getItem('user');
            if (data) {
                this.userData = JSON.parse(data);
            }
        }

        this.location = window.location;
    }

    private getActiveTabFromUrl(url: any) {
        if (url.includes('/app/help')) {
            return 'help-centre';
        }
        const currentActiveIndex = this.topNavList.findIndex(
            (list: any) => list.routePath == url
        );
        console.log('this is the current index', currentActiveIndex);

        if (currentActiveIndex > -1) {
            return {
                position: 'top',
                index: currentActiveIndex,
            };
        }
        return { position: 'top', index: 0 };
    }
    handleAuthenticatedUser(): void {
        this.loginService.me().subscribe({
            next: (user: any) => {
                console.log('user', user);
                this.sharedService.userDataSubject.next(user);
                localStorage.setItem('user', JSON.stringify(user));
            },
            error: error => {
                // alert('login failed');
                console.error('Error in me() call:', error);
                this.handleLogout();
            },
        });
    }
    handleLogout(): void {
        // this.auth0.logout({
        //     logoutParams: {
        //         returnTo: environment.default_return_url,
        //     },
        // });
        window.location.href = 'https://hsm.dev.datax.ai/';
        localStorage.removeItem('user');
        // this.router.navigate(['/login']);
    }
    handleRedirectErrors(): void {
        const params = new URLSearchParams(window.location.search);
        const error = params.get('error');
        const errorDescription = params.get('error_description');

        if (error && !sessionStorage.getItem('redirected')) {
            console.error(
                `Auth0 redirect error: ${error} - ${errorDescription}`
            );
            sessionStorage.setItem('redirected', 'true'); // prevent loop
            localStorage.removeItem('user');
            setTimeout(() => {
                location.replace('https://hsm.dev.datax.ai/');
            }, 100);
        }
    }

    onToggleNavigation(event: any) {
        this.toggleNav = event.expanded;
    }
    openHelpManual = () => {
        console.log('Help Center Clicked');
        this.activeTab.next('help-centre');
        // this.router.navigate(['app/help'], { skipLocationChange: false });
          const link = document.createElement('a');
  link.href = this.router.serializeUrl(
    this.router.createUrlTree(['/app/help'])
  );
  link.target = '_blank';
  link.click();
    };

    onLogoutClick = () => {
        // this.loginService.logOut().subscribe({
        //     next: () => {
        // localStorage.clear();
         sessionStorage.setItem('isLoggingOut', 'true');
        this.auth0.logout({
            logoutParams: {
                returnTo: 'https://hsm.dev.datax.ai/',
            },
        });

        localStorage.removeItem('filterApplied');
        localStorage.clear();
        this.sharedService.clearAll();
        //     },
        // });
    };
    // const cameFromCookie = document.cookie
    //     ?.split(';')
    //     ?.find(el => el.trim().startsWith('origin='))
    //     ?.split('origin=')[1];
    // const returnPathFromCookie =
    //     cameFromCookie && cameFromCookie !== 'undefined'
    //         ? `https://${cameFromCookie}`
    //         : environment.default_return_url;
    // localStorage.clear();
    // // alert(environment.default_return_url);
    // this.auth0.logout({
    //     logoutParams: {
    //         returnTo: environment.default_return_url,
    //     },
    // });
    // };
}
